import { attr, belongsTo } from '@ember-data/model';
import ShModel from './sh-model';

const TYPES = {
  ESTIMATED_SHOOT_DATE: 0,
  EXACT_SHOOT_DATE: 1,
  KEY_MEETING: 2,
  COMPLETION_DEADLINE: 3,
  OTHER_TYPE: 10,
};

export const ASSIGNMENT_SCHEDULE = {
  TYPES,
};

class AssignmentSchedule extends ShModel {
  @attr('number') type;
  @attr('string') description;
  @attr('date') date;

  @belongsTo('assignment', { async: false }) assignment;
}

export default AssignmentSchedule;

